<div class="row page-center no-permission">
    <img src="../../assets/img/no-permission.png">
</div>